module.exports = __webpack_public_path__ + "img/bluesky33.1debf47f.jpg";